/**
 * Matches the arbitrator query keys that carry `is_stale` — the session detail
 * (`/api/arbitrator/sessions/<id>`) and the by-job-stage lookup. These are
 * recomputed server-side from current stage membership, so they must be
 * invalidated after ANY mutation that can move a candidate (pipeline
 * advance/reject/move, etc.), not just the arbitrator's own actions — otherwise
 * the "profiles may have changed" banner stays stale until a hard refresh.
 *
 * Deliberately excludes the results list (`/api/arbitrator/sessions/<id>/results`)
 * and other sub-resources so a mutation doesn't trigger a heavy list refetch.
 */
const SESSION_DETAIL_KEY = /^\/api\/arbitrator\/sessions\/[^/]+$/;
const BY_JOB_STAGE_PREFIX = "/api/arbitrator/sessions/by-job-stage/";

export function isArbitratorSessionStaleQueryKey(
  queryKey: readonly unknown[],
): boolean {
  const first = queryKey[0];
  if (typeof first !== "string") return false;
  return SESSION_DETAIL_KEY.test(first) || first.startsWith(BY_JOB_STAGE_PREFIX);
}
